import BrowserHistory from '../browser-history';
import Referrer from '../referrer';
import updateYmCounter from '../ym';

class HistoryObserver {
	static DEFAULT_OPTIONS = {
		root: document.querySelector('.xgallery'),
		rootMargin: '100px',
		threshold: 1,
	};

	constructor(options, liveInternet = false, yandexMetr = false) {
		this.options = { ...HistoryObserver.DEFAULT_OPTIONS, ...options };
		this.targets = [];
		this.previousSeoUrl = null;
		this.isFirstCall = true;
		this.liveInternet = liveInternet;
		this.yandexMetr = yandexMetr;
	}

	#callback(entries) {
		entries.forEach((entry) => {
			if (entry.isIntersecting && entry.intersectionRect) {
				if (this.isFirstCall) {
					this.isFirstCall = false;
					return;
				}

				const referrer = location.href;
				let seoUrl = entry.target.dataset?.href;
				if (seoUrl) {
					seoUrl = seoUrl?.substring(seoUrl?.lastIndexOf('/') + 1);

					if (!window.location.href.includes(seoUrl) && seoUrl !== this.previousSeoUrl) {
						BrowserHistory.replaceHistoryState({ page: seoUrl }, seoUrl);
						this.previousSeoUrl = seoUrl;
						const currentUrl = location.href;
						if (this.liveInternet) new Referrer(referrer, currentUrl).setCounter();
						if (this.yandexMetr) updateYmCounter(referrer, currentUrl);
					}
				}
			}
		});
	}

	init() {
		this.targets = this.options.root.querySelectorAll('.gallery-list__item');

		const observer = new IntersectionObserver(this.#callback.bind(this), this.options);
		this.targets.forEach((target) => {
			observer.observe(target);
		});
	}
}

export default HistoryObserver;
